import HeaderBar from "../../../Components/UI/headerbar";
import CommissionSettingsTab from "../components/CommissionSettingsTab";

const CommissionSettingsPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar
        title="إدارة الماليات"
        content="إدارة المدفوعات والعمولات والمدفوعات."
      />
      <CommissionSettingsTab />
    </div>
  );
};

export default CommissionSettingsPage;
